<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout wrap>
      <v-flex
        md12
        sm12
        lg6
      >
        <material-chart-card
          :data="clientChart.data"
          :options="clientChart.options"
          color="gray"
          type="Bar"
        >
          <h4 class="title font-weight-light">New Clients by Month</h4>
          <p class="category d-inline-flex font-weight-light">
            <span v-if="this.clientIncrease >= 0">
              <v-icon
                color="green"
                small
              >
                mdi-arrow-up
              </v-icon>
              <span class="green--text">{{ this.clientIncrease }}%</span>&nbsp;
              increase in this month's clients
            </span>
            <span v-else>
              <v-icon
                color="red"
                small
              >
                mdi-arrow-down
              </v-icon>
              <span class="red--text">{{ this.clientIncrease }}%</span>&nbsp;
              decrease in this month's clients
            </span>
          </p>

        </material-chart-card>
      </v-flex>
      <v-flex
        md12
        sm12
        lg6
      >
        <material-chart-card
          :data="subscriptionChart.data"
          :options="subscriptionChart.options"
          color="gray"
          type="Bar"
        >
          <h4 class="title font-weight-light">Money by Month</h4>

        </material-chart-card>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'Dashboard',
    data () {
      return {
        payout: 0,
        clients: [],
          subscriptionLabels: [],
          subscriptionSeries: [],
        clientIncrease: 0,
        user: JSON.parse(localStorage.getItem('userInfo'))
      }
    },
    computed: {
      clientChart: function () {
        let date = new Date()
        var labels = this.clients.map(c => c.month)
        if (labels.length == 0) {
          labels = [ date.getFullYear() + '-' + (date.getMonth() + 1) ]
        }
        var series = this.clients.map(c => parseFloat(c.count))
        var high = Math.max(...series)
        if (series.length == 0) {
          series = [ 0 ]
          high = 1
        }

        return {
          data: {
            labels: labels,
            series: [
              series
            ]
          },
          options: {
            lineSmooth: this.$chartist.Interpolation.cardinal({
              tension: 0
            }),
            low: 0,
            high: high + 0.1,
            onlyInteger: true,
            chartPadding: {
              top: 20,
              right: 0,
              bottom: 0,
              left: 20
            },
            showLabel: true
          }
        }
      },
        subscriptionChart: function () {
            let date = new Date()
            var labels = this.subscriptionLabels
            if (labels.length == 0) {
                labels = [ date.getFullYear() + '-' + (date.getMonth() + 1) ]
            }
            // var series = this.subscriptionSeries; //Object.values(this.recurringSubscriptions);

            // console.log(series)
            // var high = Math.max(...series);
            // if (series.length == 0) {
            //     series = [ 0 ];
            //     high = 1;
            // }

            return {
                data: {
                    labels: labels,
                    series: this.subscriptionSeries
                },
                options: {
                    lineSmooth: this.$chartist.Interpolation.cardinal({
                        tension: 0
                    }),
                    low: 0,
                    onlyInteger: false,
                    chartPadding: {
                        top: 20,
                        right: 0,
                        bottom: 0,
                        left: 0
                    },
                    showLabel: true,
                    stackBars: true
                }
            }
        }
    },
    watch: {
      clients (val) {
        if (val.length === 0) {
          this.clientIncrease = 0
          return
        }

        var cur = parseFloat(val[val.length - 1].count)
        if (val.length > 1) {
          var pre = parseFloat(val[val.length - 2].count)
          this.clientIncrease = (cur - pre) / pre * 100
        } else {
          this.clientIncrease = 100
        }
      }
    },
    created () {
      // this.getClients();
      // this.getReccuringSubscription();
      // this.getOneTimeSubscription();
    },
    methods: {
      complete (index) {
        this.list[index] = !this.list[index]
      },
      getClients () {
        // axios.get('/api/reports/clients')
        //         .then(response => {
        //           this.clients = response.data
        //         })
        //         .catch(err => {
        //           console.log(err.response.data.errors)
        //         })
        axios.get('/api/admin/clients/report')
                .then(response => {
                  this.clients = response.data
                })
                .catch(err => {
                  console.log(err.response.data.errors)
                })
      },
        getReccuringSubscription () {
            axios.get('/api/admin/subscriptions/recurring')
                .then(response => {
                    this.subscriptionLabels = Object.keys(response.data)
                    this.subscriptionSeries.push(Object.values(response.data))
                })
                .catch(err => {
                    console.log(err.response.data.errors)
                })
        },
        getOneTimeSubscription () {
            axios.get('/api/admin/subscriptions/onetime')
                .then(response => {
                    this.subscriptionSeries.push(Object.values(response.data))
                })
                .catch(err => {
                    console.log(err.response.data.errors)
                })
        },
      getPayout () {
        axios.get('/api/reports/payout')
                .then(response => {
                  this.payout = response.data
                })
                .catch(err => {
                  console.log(err.response.data.errors)
                })
      }
    }
  }
</script>
